import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button, Typography, Card} from 'antd';

import * as types from 'reducer/actionTypes';

const AdapterImportAndExport = ({ t, adapterName, tabName }) => {
        const { Title } = Typography;
        const interfaceName = "Import & Export"
		const dispatch = useDispatch();

		const fetchSetUniAdapterImportInfo = () => {
			dispatch({type: types.FETCH_SET_UNIADAPTER_IMPORT_REQUEST})
		}

		const handleExport = async () => {
			if (!('showSaveFilePicker' in window)) {
			  alert('해당 브라우저가 파일 저장을 지원하지 않습니다.');
			  return;
			}
		  
			try {
			  const fileHandle = await window.showSaveFilePicker({
				suggestedName: 'export.json',
				types: [{
				  description: 'JSON File',
				  accept: { 'application/json': ['.json'] },
				}],
			  });
		  
			  dispatch({
				type: types.FETCH_GET_UNIADAPTER_EXPORT_REQUEST,
				value: {
				  adapterName,
				  fileHandle,
				},
			  });
			} catch (err) {
			  console.error('파일 저장 위치 선택 취소됨 또는 오류:', err);
			}
		};

		const handlerImport = async () => {
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = '.json';
		  
			input.onchange = (event) => {
			  const file = event.target.files[0];
			  if (!file) return;
		  
			  if (file.type !== 'application/json') {
				alert('json 파일만 업로드 가능합니다.');
				return;
			  }
		  
			  dispatch({
				type: types.FETCH_SET_UNIADAPTER_IMPORT_REQUEST,
				value: { file }
			  });
			};
		  
			input.click();
		  };
		  

	return (
		<div style={{ padding: '20px', margin: 'auto' }}>
			<Title level={2}>{interfaceName}</Title>
			<Card
				type="inner"
				title="Export"
				style={{ marginTop: 20 }}>
				<Form.Item>
					<Button type="primary" 
							onClick={handleExport} 
							style={{ marginTop:10 }}>
						 	New Export 
					</Button>
				</Form.Item>
			</Card>
			<Card
				type="inner"
				title="Import"
				style={{ marginTop: 20 }}>
				<Form.Item>
					<Button type="primary" 
							onClick={handlerImport} 
							style={{ marginTop:10 }}>
						 	Add File 
					</Button>
				</Form.Item>
			</Card>
		</div>
	);
}

export default AdapterImportAndExport;